<template>
  <v-container>
    <v-select
      class="mx-3"
      v-model="primarySelected"
      :items="primaryTopics"
      item-text="topic"
      :label="initialLabel"
      hint="Primary topics"
      persistent-hint
      return-object
      single-line
      clearable
      multiple
      @change="onTopicChange(-1)"
    ></v-select>
    <v-col v-for="field in fields" v-bind:key="field.index">
      <v-select
        class="mx-3"
        v-model="field.selected"
        :items="field.values"
        item-text="topic"
        :label="sublabel"
        hint="Subtopics"
        persistent-hint
        return-object
        single-line
        clearable
        multiple
        @change="onTopicChange(field.index)"
      ></v-select>
    </v-col> </v-container
></template>

<script>
import topicsHierarchy from "../mixins/topicsHierarchy";

export default {
  name: "TopicsHierarchy",
  mixins: [topicsHierarchy],
  data: () => ({
    fields: [],
    primarySelected: [],
    initialLabel: "Select primary topics for this question",
    sublabel: "Select optional subtopics for this question"
  }),
  computed: {
    primaryTopics() {
      return this.getTopics().filter(t => t.type == "primary");
    },
    allTopics() {
      return this.getTopics();
    }
  },
  watch: {
    allTopics() {
      const update = p => this.allTopics.filter(a => a.topic === p.topic)[0];
      this.primarySelected = this.primarySelected.map(update);
      this.fields.forEach(
        field => (field.selected = field.selected.map(update))
      );
      this.onTopicChange(this.fields.length - 1);
    }
  },
  methods: {
    onTopicChange(index) {
      let subtopics = [];
      const field =
        index > -1
          ? this.fields[index]
          : {
              index: -1,
              values: this.primaryTopics,
              selected: this.primarySelected
            };
      field.selected.forEach(topic => {
        subtopics = subtopics.concat(topic.subtopics);
      });
      //The adding logic is kind of a mess but it works.
      subtopics = this.allTopics.filter(t => subtopics.includes(t.topic));
      if (this.fields.length == index + 1) {
        if (subtopics.length > 0) {
          this.fields.push({
            index: this.fields.length,
            values: subtopics,
            selected: []
          });
        }
      } else {
        if (subtopics.length == 0 && this.fields.length > index + 1) {
          this.fields.splice(index + 1, 1);
        } else {
          this.fields[index + 1].values = subtopics;
        }
      }
      const returnTopics = {
        primary: this.primarySelected.map(t => t.topic),
        subtopics: []
      };
      this.fields.forEach(field => {
        returnTopics.subtopics = returnTopics.subtopics.concat(
          field.selected.map(t => t.topic)
        );
      });
      this.$emit("topicsChanged", returnTopics);
    }
  }
};
</script>

<style scoped></style>
